import React, { useState } from 'react'
import { Grid, Card, Popover, Typography, Checkbox } from '@mui/material'
import * as IssueEntity from '../../Entities/IssueTypes'
import { BsThreeDotsVertical } from 'react-icons/bs'
import { RiChatHistoryLine } from 'react-icons/ri'
import { LuCalendarDays } from 'react-icons/lu'
import { useTranslation } from 'react-i18next'
import IssueTable from './IssueTable'
import { useIssueStore } from './store/IssueStore'

const IssueRaisedComponent = ({ riskType, headerTabs, selectedMenu, handleSelect }) => {
    const { t } = useTranslation()
    const [ isModalOpen, setIsModalOpen ] = useState(false)
    const {
        issueInitialCount, issuePlanningCount,
        issuePendingCount,
        issueCloseCount
    } = useIssueStore(state => ({
        issueInitialCount: state.issueInitialCount,
        issuePlanningCount: state.issuePlanningCount,
        issuePendingCount: state.issuePendingCount,
        issueCloseCount: state.issueCloseCount
    }))
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen)
    }
    const openModal = () => {
        setIsModalOpen(true)
    }

    const TableHeaders = IssueEntity.ISSUE_TABLE_HEADERS?.map((mapData) => {
        if (mapData?.field === IssueEntity.DOT) {
            return {
                ...mapData,
                renderCell: (params) => (
                    <div>
                        <BsThreeDotsVertical onClick={openModal} className='mt-3 '/>
                    </div>
                )
            }
        } else if (mapData?.field === 'checkbox') {
            return {
                ...mapData,
                renderCell: (params) => (
                    <Checkbox
                        checked={!!params.value}
                    />
                )
            }
        } else return mapData
    })
    const countFinder = (id) => {
        switch (id) {
        case 1:
            return issueInitialCount
        case 2:
            return issuePlanningCount
        case 3:
            return issuePendingCount
        case 4:
            return issueCloseCount
        default:
            return 0
        }
    }
    const tableBodyData = useIssueStore((state) => state.tableBodyData)
    return (
        <div className='h-[100%] flex flex-col gap-4'>
            <Grid container gap={0} direction="row" justifyContent="space-between" className='px-5 w-[100%] items-center' >
                {
                    headerTabs?.map((item, i) => {
                        return (
                            <>
                                {item.show && <Grid item xs={2.5} sm={2.5} md={2.5}>
                                    <div
                                        className={`heatmap-card ${item.selected ? 'selectedCard' : ''}`}
                                        onClick={() => handleSelect(item.id, item?.name)}
                                    >
                                        <Card className='p-5 border-2 heatmap-card-content flex' style={{
                                            border: item.selected ? '2px solid hsl(var(--primary))' : '2px solid hsl(var(--card))',
                                            background: item.selected ? 'hsl(var(--primary-foreground))' : 'hsl(var(--card))'
                                        }}>
                                            <div aria-label="" role="img" className="flex-shrink-0 flex justify-center items-center risk-avatar m-2" style={{
                                                backgroundColor: item.selected ? 'hsl(var(--primary))' : 'hsl(var(--primary-foreground))'
                                            }}>

                                                <div className='ml-2 mt-2'>{!item.selected ? item.selImg : item.defImg}</div>
                                            </div>
                                            <div className='flex flex-col justify-center pl-2'>
                                                <h3 className='font-bold text-muted'>{countFinder(item.id) || 0}</h3>
                                                <div className='text-h4 text-primary'>{item?.name}</div>
                                            </div>
                                        </Card>
                                    </div>
                                </Grid>}
                            </>

                        )
                    })
                }
            </Grid>
            <div className='mx-6 h-[100%]'>
                <IssueTable riskType={riskType} tableBodyData={tableBodyData} tableHeaders={TableHeaders} selectedMenu={selectedMenu} />
            </div>
            <Popover
                open={isModalOpen}
                onClose={toggleModal}
                className='p-2'
                anchorReference="anchorPosition"
                anchorPosition={{ top: 250, left: 1320 }}>
                {/* <div className='flex'><RiVideoAddLine className='m-3'/><Typography sx={{ p: 1 }}>{t('Meeting')} </Typography></div> */}
                <div className='flex'><LuCalendarDays className='m-3'/><Typography sx={{ p: 1 }}>{t('Set Reminder')}</Typography></div>
                <div className='flex'><RiChatHistoryLine className='m-3'/><Typography sx={{ p: 1 }}>{t('Chat & Timeline')} </Typography></div>
            </Popover>
        </div>
    )
}

export default IssueRaisedComponent
